<script setup>
import { ref } from 'vue';

const showButton = ref(false);

// listen for scroll events
window.addEventListener('scroll', () => {
  // if the user has scrolled 100px or more, show the button
  showButton.value = window.scrollY > 100;
});

// scroll to the top of the page
const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
</script>
<template>
  <button
    v-if="showButton"
    class="hidden sm:block fixed bottom-4 right-4 bg-primary-700 text-white rounded-full p-2 shadow-md"
    @click="scrollToTop"
  >
    <v-icon icon="mdi-arrow-up" size="large"></v-icon>
  </button>
</template>
